export default {
    // "배달할 수 없는 지역으로 요청되어 취소된 경우",
    INVALID_AREA: 'INVALID_AREA',
    // "라이더 사고로 인해 배달이 취소된 경우",
    RIDER_ACCIDENT: 'RIDER_ACCIDENT',
    // front 사용: 주문폭주
    // "배달을 수행할 수 있는 라이더가 부족하여 배달이 취소된 경우",
    OVER_CAPACITY: 'OVER_CAPACITY',
    // front 사용: 기상 악화
    // "배달 불가능한 날씨로 인해 배달이 취소된 경우",
    BAD_WEATHER: 'BAD_WEATHER',
    // "배달대행사의 영업이 종료되어 배달이 취소된 경우",
    CLOSE_AGENCY: 'CLOSE_AGENCY',
    // "상점의 영업이 종료되어 배달이 취소된 경우",
    CLOSE_STORE: 'CLOSE_STORE',
    // "상점의 예치금이 부족하여 배달이 취소된 경우",
    INSUFFICIENT_DEPOSIT: 'INSUFFICIENT_DEPOSIT',
    // "배달 접수 후 잘못된 정보로 인해 배달이 취소된 경우",
    WRONG_REQUEST: 'WRONG_REQUEST',
    // "고객 정보가 정확하지 않아 배달이 취소된 경우",
    WRONG_RECEIVER_INFO: 'WRONG_RECEIVER_INFO',
    // "고객과 연락이 되지 않아 배달이 취소된 경우",
    NOT_ANSWER_RECEIVER: 'NOT_ANSWER_RECEIVER',
    // "고객의 요청으로 배달이 취소된 경우",
    CHANGE_CUSTOMER_MIND: 'CHANGE_CUSTOMER_MIND',
    // "배달 상품이 손상되어 배달이 취소된 경우",
    DAMAGE_PRODUCT: 'DAMAGE_PRODUCT',
    // "다른 브랜드 상점으로 변경하여 배달이 취소된 경우",
    CHANGE_STORE: 'CHANGE_STORE',
    // "배달할 상품이 품절되어 배달이 취소된 경우",
    SOLD_OUT: 'SOLD_OUT',
    // "중복된 주문 접수로 인해 주문이 취소된 경우",
    DUPLICATE_ORDER: 'DUPLICATE_ORDER',
    // front 사용: 상점 요청
    // "상점 요청으로 인해 배달이 취소된 경우",
    CANCEL_BY_STORE: 'CANCEL_BY_STORE',
    // "고객 요청으로 주문이 취소된 경우",
    CANCEL_BY_CUSTOMER: 'CANCEL_BY_CUSTOMER',
    // "관리자 요청으로 배달을 취소시키는 경우",
    CANCEL_BY_ADMIN: 'CANCEL_BY_ADMIN',
    // "주문 수락 시간 초과로 인해 배달 취소시키는 경우",
    CANCEL_BY_TIMEOUT: 'CANCEL_BY_TIMEOUT',
    // "고객의 불만 요청으로 주문이 취소된 경우",
    COMPLAIN_BY_CUSTOMER: 'COMPLAIN_BY_CUSTOMER',
    // "배달 지연으로 인해 배달이 취소된 경우",
    DELAY_DELIVERY: 'DELAY_DELIVERY',
    // "불필요한 주문 접수로 판단되어 배달을 취소시키는 경우",
    UNNECESSARY_ORDER: 'UNNECESSARY_ORDER',
    // "실수로 접수된 주문을 관리자가 취소시키는 경우",
    MISTAKE_BY_ADMIN: 'MISTAKE_BY_ADMIN',
    // "기타 사유로 인해 배달이 취소된 경우";
    ETC: 'ETC',
};
